import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const CustomTooltip = ({ text, positionLeft }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Determine screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust the breakpoint as needed
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call initially to set the correct state

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleMouseEnter = () => {
    if (!isMobile) setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    if (!isMobile) setShowTooltip(false);
  };

  const handleClick = () => {
    if (isMobile) setShowTooltip(!showTooltip);
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <img src="/images/info-purple.svg" alt="info" />
      {showTooltip && (
        <div
          className="absolute bottom-6 z-10 w-65 -translate-x-1/2 whitespace-nowrap text-wrap rounded-lg border border-grey-500 bg-white p-2 text-ft12-14 text-grey-700 opacity-100 transition-opacity duration-300"
          style={{ left: positionLeft ? `${positionLeft}px` : "50%" }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

CustomTooltip.propTypes = {
  text: PropTypes.isRequired,
  positionLeft: PropTypes.number
};

export default CustomTooltip;
